import $ from "jquery";

doScroll();
$(window).scroll(doScroll);

function doScroll() {
    var scrollTop = $(window).scrollTop();
    var isMobile = false;
    if ($(window).width() < 992) {
        isMobile = true;
    }

    doFixedHeader(isMobile, scrollTop);
    doCategoryNav(isMobile, scrollTop);
}

function doCategoryNav(isMobile) {
	var scrollTop = $(window).scrollTop();

    if (isMobile) {
        $('#collapseCategory').css({ top: '' });
    } else {
        var mainNavHeight = $('.main-nav').outerHeight();
        var secondaryNavHeight = $('.nav-wrapper').outerHeight();
        $('#collapseCategory').css({ top: scrollTop + secondaryNavHeight + mainNavHeight - 5 });
    }
}

function doFixedHeader(isMobile, scrollTop) {
	var changed = false;

    if (scrollTop >= 100) {

	    if (!$('body').hasClass('fixed-header')) {
		    $('body').addClass('fixed-header');
		    changed = true;
	    }
    }
    else {
	    if ($('body').hasClass('fixed-header')) {
            $('body').removeClass('fixed-header');

            changed = true;
	    }
    }

    if (changed) {
        var interval = setInterval(() => {
                doCategoryNav(isMobile, scrollTop);
            },
            100);

        setTimeout(() => {
	        clearInterval(interval);
        }, 2000);
    }
}

setTimeout(function () {
    $('body').removeClass('no-transition');
}, 100);


$(document).ready(function () {
    $(document).click(function (event) {
        var clickover = $(event.target);
        var _opened = $("#collapseCategory").hasClass("show");
        if (_opened === true && (!clickover.hasClass(".dropdown-toggle") && clickover.closest("#collapseCategory").length === 0)) {
            $("#categoryDropdown").click();
        }
    });
});

$('.dropdown-menu.login-menu').on('click', function (event) {
    if ($(event.target).hasClass('custom-control-input')) {
        return;
    }

	// The event won't be propagated up to the document NODE and 
	// therefore delegated events won't be fired
	event.stopPropagation();
});